import { Play } from 'lucide-react';
import { useState } from 'react';
import { MediaBackdrop } from 'v5/design-system/MediaBackdrop';
import { MediaBadge } from 'v5/design-system/MediaBadges';
import { LayerPicture, PictureLayers } from 'v5/design-system/MediaPicture';
import { MediaThumbnail, type MediaThumbnailFile } from './MediaThumbnail';
import { mediaKindOf } from './uploadedMedia';

/**
 * An immersive tile's picture: the whole of it, never past its own size, on its blurred copy as
 * the media dialog shows it, faded in once loaded; a video's poster with the play mark. A file
 * with no picture, or one that doesn't load, shows its kind (`MediaThumbnail`), a video still
 * with its play mark.
 */
export function MediaPaddedThumbnail({
  item
}: {
  /** `localCopy`: the picture is the local copy of a fresh upload, already in memory: shown at once. */
  item: MediaThumbnailFile & { localCopy?: boolean };
}) {
  const [failed, setFailed] = useState(false);
  const kind = mediaKindOf(item);
  const picture = kind === 'image' ? item.src : item.poster;
  if (picture === undefined || failed) {
    // a failed picture once more, to show what it shows then: the kind, a video's play mark
    return <MediaThumbnail item={item} />;
  }
  return (
    <PictureLayers
      subject={picture}
      under={<MediaBackdrop src={picture} />}
      instant={item.localCopy}
    >
      <LayerPicture
        src={picture}
        fallbackSrc={item.fallbackSrc}
        contained
        onFailed={() => setFailed(true)}
      />
      {kind === 'video' && (
        <MediaBadge>
          <Play className="fill-current" />
        </MediaBadge>
      )}
    </PictureLayers>
  );
}
